import React, { ReactNode } from 'react';
import { IModuleInfo } from '../../../../redux/progress/module/moduleInterface';
import { connect } from 'react-redux';
import { TitleBlock } from '../../../../components/titleBlock/TitleBlock';
import './ModuleStatusViewer.css'
import { FormattedMessage } from 'react-intl';
import { FileType } from '../../../../components/fileView/FileType';
import httpRequest from '../../../../utils/HttpRequest';
import { urls } from '../../../../config/url';
import { IModuleParams } from '../../../../redux/progress/param/paramReducer';
import { IState } from '../../../../redux/store';
import { IJob2, IJob2s, Job2Status } from '../../../../redux/progress/job2/job2Interface';
import { IJobName } from '../../../../redux/progress/jobname/jobnameReducer';
import { useParams } from 'react-router';
// import { useUIStack } from 'uistack';
import { FileViewFetchTrigger, FileViewerFetchTriggerProps } from '../../../../components/fileView/FileViewTrigger';
import NewTitle from '../../../../components/title/newTitle';

function ModuleStatusViewer(props: {
    modules: IModuleInfo[],
    activeIndex: number,
    job2s: IJob2s
    userName: string,
    activeProjectName: string,
    params: IModuleParams,
    jobnames: IJobName,
    acitveLineName: string,
    titleBlock?: (children?: ReactNode) => ReactNode,
    logButton?: (props: FileViewerFetchTriggerProps) => ReactNode,
    addParam?: { [key: string]: any }
}) {
    // const uistack = useUIStack();
    const module = props.modules[props.activeIndex];
    let job: IJob2 = {
        status: Job2Status.waiting,
        jobName: "",
        log: []
    };
    if (module && props.job2s[module.PRO_MODULE_NAME])
        job = props.job2s[module.PRO_MODULE_NAME];

    const info: JSX.Element[] = [];
    // for (let key in job.info) {
    //     if (key === "jobName") {
    //         continue;
    //     }
    //     info.push(
    //         <div key={key}>{`${key}: ${job.info[key]}`}</div>
    //     )
    // }
    const { spec, tech } = useParams<{ spec: string, tech: string }>();

    for (let view of job.log) {
        info.push(
            <FormattedMessage id={view.name} defaultMessage={view.name} key={view.name} description="running info">
                {(text) => {
                    return (
                        <div key={view.name}>{`${text}: ${view.value}`}</div>
                    )
                }}
            </FormattedMessage>
        )
    }

    const fetchTriggerPramas: FileViewerFetchTriggerProps = {
        name: 'log',
        type: FileType.TEXT,
        fetch: async () => {
            try {
                const res = await httpRequest(urls.getjoblog, {
                    USER_NAME: props.userName,
                    PROJECTNAME: props.activeProjectName,
                    JOB_NAME: props.jobnames[module.PRO_MODULE_NAME],
                    SPECIALITYCLASS: spec,
                    TECHNOLOGYCLASS: tech,
                    proj_name: props.acitveLineName,
                    ...props.addParam,
                })
                let data = res.data;
                if (data.errno === 0) {
                    return data.data;
                } else {
                    return data.errmsg;
                }

            } catch {
                return 'http error'
            }
        }
    }

    const content = (
        <>

            <div style={{position: 'relative'}}>
                <div className="running-info">
                    {info}
                </div>
                {
                    props.logButton
                        ?
                        props.logButton(fetchTriggerPramas)
                        :
                        <FileViewFetchTrigger {...fetchTriggerPramas} >
                            <button className='btn running-info-button' style={{ position: 'absolute', top: 45, borderRadius: 5, background: '#0e4adf' }}>
                                日志显示
                            </button>

                        </FileViewFetchTrigger>
                }
            </div>


            {/* <FileViewFetchTrigger
                name={'log'}
                type={FileType.TEXT}
                fetch={async () => {
                    try {
                        const res = await httpRequest(urls.getjoblog, {
                            USER_NAME: props.userName,
                            PROJECTNAME: props.activeProjectName,
                            JOB_NAME: props.jobnames[module.PRO_MODULE_NAME],
                            SPECIALITYCLASS: spec,
                            TECHNOLOGYCLASS: tech,
                            proj_name: props.acitveLineName,
                        })
                        let data = res.data;
                        if (data.errno === 0) {
                            return data.data;
                        } else {
                            return data.errmsg;
                        }

                    } catch {
                        return 'http error'
                    }
                }}

            >
                <button className='btn running-info-button'>
                    日志显示
                </button>
            </FileViewFetchTrigger> */}
        </>
    )

    return (
        <>
            <div style={{ marginTop: 20 }}>

                <div className='messageClass' style={{ marginBottom: 10 }}>
                    <span>运行信息</span>
                </div>


                {
                    props.titleBlock ? props.titleBlock(content) : <TitleBlock titleId="running_info">
                        {content}
                    </TitleBlock >
                }



                {/* {
                    props.titleBlock ? props.titleBlock(content) : <TitleBlock titleId="running_info">
                        {content}
                    </TitleBlock >
                } */}
            </div>
        </>

    )

}


const mapStateToProps = (state: IState) => {
    return {
        modules: state.progress.modules.modules,
        activeIndex: state.progress.modules.activeIndex,
        job2s: state.progress.job2s,
        userName: state.user.userName,
        activeProjectName: state.project.activeName,
        params: state.progress.params,
        jobnames: state.progress.jobnames,
        acitveLineName: state.progress.line.activeName,
    };
};

export default connect(
    mapStateToProps
)(ModuleStatusViewer);